"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentsHeading = exports.ScheduleAppointmentHeading = exports.FullWidthButtonLinkWithIcon = exports.FullWidthButtonLink = exports.OpenSchedulingIFrame = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const button_1 = require("@kyruus/button");
const ui_theme_1 = require("@kyruus/ui-theme");
exports.OpenSchedulingIFrame = styled_1.default.iframe `
  width: 100%;
  border: 0;
  height: 400px;
  margin-top: 12px;
`;
exports.FullWidthButtonLink = (0, styled_1.default)(button_1.ButtonLink) `
  &&& {
    display: block;
    padding: 12px;
    margin-top: 12px;
    margin-bottom: 12px;
    text-align: center;
  }
`;
exports.FullWidthButtonLinkWithIcon = (0, styled_1.default)(button_1.ButtonLinkWithIcon) `
  display: block;
  padding: 12px;
  margin-top: 12px;
  margin-bottom: 12px;
`;
const Heading = styled_1.default.h2 `
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
  margin: 0;
  grid-area: title;
`;
exports.ScheduleAppointmentHeading = Heading;
exports.AppointmentsHeading = Heading;
//# sourceMappingURL=styles.js.map